module.exports = __webpack_public_path__ + "img/annotation-note.832e3217.svg";